/* eslint-disable jsx-a11y/anchor-is-valid */
import { useDispatch, useSelector } from "react-redux";
import {
  resetForm,
  setSubmitSuccess,
  setSubmitting,
  updateFormData,
} from "../../redux/actions";
import { CheckCircle, MapPin, Phone, User } from "lucide-react";

export const Contact = () => {
  const dispatch = useDispatch();
  const company = useSelector((state) => state.company);
  const { formData, isSubmitting, submitSuccess } = useSelector(
    (state) => state.contact,
  );

  const handleChange = (e) => {
    dispatch(updateFormData({ [e.target.name]: e.target.value }));
  };

  const handleSubmit = () => {
    if (!formData.name || !formData.phone || !formData.message) return;

    // Format pesan WhatsApp
    const waMessage = `Halo Rajut Sari Asa!

Nama: ${formData.name}
No. HP: ${formData.phone}
${formData.email ? `Email: ${formData.email}` : ""}

Pesan:
${formData.message}`;

    const waNumber = "6282144335897";

    const encodedMessage = encodeURIComponent(waMessage);

    const waUrl = `https://wa.me/${waNumber}?text=${encodedMessage}`;
    window.open(waUrl, "_blank");

    dispatch(setSubmitting(true));
    setTimeout(() => {
      dispatch(setSubmitting(false));
      dispatch(setSubmitSuccess(true));
      setTimeout(() => dispatch(resetForm()), 3000);
    }, 1000);
  };

  return (
    <section id="kontak" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Hubungi Kami
          </h2>
          <div className="w-24 h-1 bg-pink-600 mx-auto mb-4"></div>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Tertarik dengan produk kami? Jangan ragu untuk menghubungi kami!
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12">
          <div>
            <div className="bg-gradient-to-br from-pink-50 to-purple-50 p-8 rounded-xl shadow-lg mb-6">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">
                Informasi Kontak
              </h3>
              <div className="space-y-6">
                <div className="flex items-start">
                  <MapPin className="h-6 w-6 text-pink-600 mr-3 mt-1 flex-shrink-0" />
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Alamat</h4>
                    <p className="text-gray-700">{company.address}</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <Phone className="h-6 w-6 text-pink-600 mr-3 mt-1 flex-shrink-0" />
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">
                      WhatsApp
                    </h4>
                    <a
                      href="https://wa.me/6282144335897"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-gray-700 hover:text-pink-600 transition-colors"
                    >
                      +62 821-4433-5897
                    </a>
                  </div>
                </div>
                <div className="flex items-start">
                  <User className="h-6 w-6 text-pink-600 mr-3 mt-1 flex-shrink-0" />
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">
                      Pemilik
                    </h4>
                    <p className="text-gray-700">Luh Yasa</p>
                  </div>
                </div>
              </div>

              <div className="mt-8 pt-8 border-t border-gray-300">
                <h4 className="font-semibold text-gray-900 mb-4">Ikuti Kami</h4>
                <div className="flex gap-4">
                  <a
                    href="https://www.facebook.com/luh.yasa.169?locale=id_ID"
                    className="bg-white p-3 rounded-full hover:bg-pink-100 transition-colors"
                  >
                    <img
                      src="/facebook.png"
                      alt="logo"
                      className="text-pink-600"
                    />
                  </a>
                  <a
                    href="#"
                    className="bg-white p-3 rounded-full hover:bg-pink-100 transition-colors"
                  >
                    <img
                      src="/tiktok.png"
                      alt="logo"
                      className="text-pink-600"
                    />
                  </a>
                  <a
                    href="#"
                    className="bg-white p-3 rounded-full hover:bg-pink-100 transition-colors"
                  >
                    <img
                      src="/shoope.png"
                      alt="logo"
                      className="h-12 w-12 text-pink-600"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white p-8 rounded-xl shadow-lg border border-gray-100">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">
              Kirim Pesan
            </h3>
            <div className="space-y-4">
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Nama Lengkap *"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-pink-600 focus:border-transparent"
              />
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="No. WhatsApp *"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-pink-600 focus:border-transparent"
              />
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Email (Opsional)"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-pink-600 focus:border-transparent"
              />
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Pesan / Produk yang ingin dipesan *"
                rows="5"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-pink-600 focus:border-transparent"
              ></textarea>
              <button
                onClick={handleSubmit}
                disabled={isSubmitting}
                className="w-full bg-green-600 text-white py-3 rounded-lg font-semibold hover:bg-green-700 transition-colors disabled:bg-gray-400 flex items-center justify-center gap-2"
              >
                {isSubmitting ? (
                  "Membuka WhatsApp..."
                ) : (
                  <>
                    <Phone className="h-5 w-5" />
                    Kirim via WhatsApp
                  </>
                )}
              </button>
              {submitSuccess && (
                <div className="bg-green-50 text-green-700 p-4 rounded-lg text-center font-medium flex items-center justify-center gap-2">
                  <CheckCircle className="h-5 w-5" />
                  WhatsApp berhasil dibuka! Silakan kirim pesan Anda.
                </div>
              )}
              <p className="text-sm text-gray-500 text-center">* Wajib diisi</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
